import { Fragment, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars

export const PlaceholderIcons = {
  svgArrowLeft: () => {
    return (
      <path d="M15.79 21c-.26 0-.51-.1-.71-.29l-7.29-7.29c-.78-.78-.78-2.05 0-2.83l7.29-7.29a.996.996 0 1 1 1.41 1.41L9.2 12l7.29 7.29a.996.996 0 0 1-.71 1.7Z"></path>
    );
  },
  svgArrowRight: () => {
    return (
      <path d="M8.21 21c.26 0 .51-.1.71-.29l7.29-7.29c.78-.78.78-2.05 0-2.83L8.92 3.3a.996.996 0 1 0-1.41 1.41L14.8 12l-7.29 7.29a.996.996 0 0 0 .71 1.7Z"></path>
    );
  },
  close: () => {
    return (
      <path d="m13.41 12 5.66-5.66a.996.996 0 1 0-1.41-1.41L12 10.59 6.34 4.93a.996.996 0 1 0-1.41 1.41L10.59 12l-5.66 5.66a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l5.66-5.66 5.66 5.66c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L13.43 12Z"></path>
    );
  },
  infoInverted: () => {
    return (
      <Fragment>
        <circle cx="12" cy="4" r="2"></circle>
        <path d="M12 8c-.83 0-1.5.67-1.5 1.5v11c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5Z"></path>
      </Fragment>
    );
  },
  svgFullArrowRight: () => {
    return (
      <path d="M21 11H5.05l5.33-5.33a.996.996 0 1 0-1.41-1.41l-6.41 6.41c-.36.35-.55.83-.55 1.33s.2.97.55 1.33l6.41 6.42c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-5.33-5.33h15.95c.55 0 1-.45 1-1s-.45-1-1-1Z"></path>
    );
  },
  svgArrowDown: () => {
    return (
      <path d="M21 8.21c0 .26-.1.51-.29.71l-7.29 7.29c-.78.78-2.05.78-2.83 0L3.3 8.92a.996.996 0 1 1 1.41-1.41L12 14.8l7.29-7.29a.996.996 0 0 1 1.7.71Z"></path>
    );
  },
  svgArrowUp: () => {
    return (
      <path d="M3 15.79c0-.26.1-.51.29-.71l7.29-7.29c.78-.78 2.05-.78 2.83 0l7.29 7.29a.996.996 0 1 1-1.41 1.41L12 9.2l-7.29 7.29a.996.996 0 0 1-1.7-.71Z"></path>
    );
  },
  svgAdd: () => {
    return (
      <path d="M20 10.95h-7V4c0-.55-.45-1-1-1s-1 .45-1 1v6.95H4c-.55 0-1 .45-1 1s.45 1 1 1h7V20c0 .55.45 1 1 1s1-.45 1-1v-7.05h7c.55 0 1-.45 1-1s-.45-1-1-1Z"></path>
    );
  },
};
